/**
 * 创建时间：2024年8月4日16:11:28
 * 创建人：cjt
 * 文件描述：用于储存页面中多处使用一些固定枚举值,便于后期统一维护
 * 注意：文件内容中常亮请使用全大写,下划线串联单词的形式（例： CONSTANT_EXAMPLE: '常量'）
 */
export const ZHULONG_URL = {
  LOGIN: 'http://gxygcgpt.bbwcq.com/web-login/index.html#/login',
  LOGIN_PURCHASE: 'http://gxygcgpt.bbwcq.com/web-purchase/index.html#/login',
  REGISTER: 'http://gxygcgpt.bbwcq.com/web-user-center/index.html#/reg',
}

/**
 * SELECT Options 对应的 item 的字段
 * @type {{CODE: 'value值', LABEL: '显示名称'}}
 */
export const SELECT_OPTION_CONFIG = {
  LABEL: 'label',
  CODE: 'code',
  CHILDREN: 'children',
}

/**
 * 适用于头部搜索框内,切换查询条件的下拉框
 * @type {{PROJECT_CODE: {CODE: string, LABEL: string}, PROJECT_NAME: {CODE: string, LABEL: string}}}
 */
export const SEARCH_INPUT_OPTIONS_TYPES = {
  NOTICE_NAME: {
    [SELECT_OPTION_CONFIG.LABEL]: '公告名称',
    [SELECT_OPTION_CONFIG.CODE]: '3',
  },
  PROJECT_CODE: {
    [SELECT_OPTION_CONFIG.LABEL]: '项目编号',
    [SELECT_OPTION_CONFIG.CODE]: '1',
  },
  PROJECT_NAME: {
    [SELECT_OPTION_CONFIG.LABEL]: '项目名称',
    [SELECT_OPTION_CONFIG.CODE]: '2',
  },
}

// 公告类型 枚举值
export const NOTICE_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: '全部',
    [SELECT_OPTION_CONFIG.CODE]: '0',
  },
  CG: {
    [SELECT_OPTION_CONFIG.LABEL]: '采购公告',
    [SELECT_OPTION_CONFIG.CODE]: '1',
  },
  BG: {
    [SELECT_OPTION_CONFIG.LABEL]: '变更公告',
    [SELECT_OPTION_CONFIG.CODE]: '2',
  },
  DYCQ: {
    [SELECT_OPTION_CONFIG.LABEL]: '答疑澄清',
    [SELECT_OPTION_CONFIG.CODE]: '3',
  },
  HXR: {
    [SELECT_OPTION_CONFIG.LABEL]: '候选人公示',
    [SELECT_OPTION_CONFIG.CODE]: '4',
  },
  JG: {
    [SELECT_OPTION_CONFIG.LABEL]: '结果公告',
    [SELECT_OPTION_CONFIG.CODE]: '5',
  },
}

// 项目类型枚举值
export const PROJECT_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: '全部',
    [SELECT_OPTION_CONFIG.CODE]: '0',
  },
  GC: {
    [SELECT_OPTION_CONFIG.LABEL]: '工程类',
    [SELECT_OPTION_CONFIG.CODE]: '工程',
  },
  HW: {
    [SELECT_OPTION_CONFIG.LABEL]: '货物类',
    [SELECT_OPTION_CONFIG.CODE]: '货物',
  },
  FW: {
    [SELECT_OPTION_CONFIG.LABEL]: '服务类',
    [SELECT_OPTION_CONFIG.CODE]: '服务',
  },
  // QT: {
  //   [SELECT_OPTION_CONFIG.LABEL]: "其他",
  //   [SELECT_OPTION_CONFIG.CODE]: "4"
  // }
}

// 公告状态枚举值（暂定）
export const PROJECT_STATUS_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: '全部',
    [SELECT_OPTION_CONFIG.CODE]: '0',
  },
  WKS: {
    [SELECT_OPTION_CONFIG.LABEL]: '未开始',
    [SELECT_OPTION_CONFIG.CODE]: '1',
  },
  GGZ: {
    [SELECT_OPTION_CONFIG.LABEL]: '公告中',
    [SELECT_OPTION_CONFIG.CODE]: '2',
  },
  GSZ: {
    [SELECT_OPTION_CONFIG.LABEL]: '公示中',
    [SELECT_OPTION_CONFIG.CODE]: '3',
  },
  GSJS: {
    [SELECT_OPTION_CONFIG.LABEL]: '公示结束',
    [SELECT_OPTION_CONFIG.CODE]: '4',
  },
  YZB: {
    [SELECT_OPTION_CONFIG.LABEL]: '已中标',
    [SELECT_OPTION_CONFIG.CODE]: '5',
  },
  YFB: {
    [SELECT_OPTION_CONFIG.LABEL]: '已废标',
    [SELECT_OPTION_CONFIG.CODE]: '6',
  },
  YZZ: {
    [SELECT_OPTION_CONFIG.LABEL]: '已终止',
    [SELECT_OPTION_CONFIG.CODE]: '7',
  },
}

// 采购类型（方式）
export const CG_WAY_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: '全部',
    [SELECT_OPTION_CONFIG.CODE]: '0',
  },
  GKZB: {
    [SELECT_OPTION_CONFIG.LABEL]: '公开招标',
    [SELECT_OPTION_CONFIG.CODE]: '公开招标',
  },
  YQZB: {
    [SELECT_OPTION_CONFIG.LABEL]: '邀请招标',
    [SELECT_OPTION_CONFIG.CODE]: '邀请招标',
  },
  WSXJ: {
    [SELECT_OPTION_CONFIG.LABEL]: '网上询价',
    [SELECT_OPTION_CONFIG.CODE]: '网上询价',
  },
  JZXCS: {
    [SELECT_OPTION_CONFIG.LABEL]: '竞争性磋商',
    [SELECT_OPTION_CONFIG.CODE]: '竞争性磋商',
  },
  JZXTP: {
    [SELECT_OPTION_CONFIG.LABEL]: '竞争性谈判',
    [SELECT_OPTION_CONFIG.CODE]: '竞争性谈判',
  },
  XBJ: {
    [SELECT_OPTION_CONFIG.LABEL]: '询比采购',
    [SELECT_OPTION_CONFIG.CODE]: '询比采购',
  },
  DYLY: {
    [SELECT_OPTION_CONFIG.LABEL]: '单一来源',
    [SELECT_OPTION_CONFIG.CODE]: '单一来源',
  },
}

// 组织形式
export const ORGANIZATION_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: '全部',
    [SELECT_OPTION_CONFIG.CODE]: '0',
  },
  WTCG: {
    [SELECT_OPTION_CONFIG.LABEL]: '委托代理',
    [SELECT_OPTION_CONFIG.CODE]: '委托代理',
  },
  QYZZ: {
    [SELECT_OPTION_CONFIG.LABEL]: '自行组织',
    [SELECT_OPTION_CONFIG.CODE]: '自行组织',
  },
}

export const MAP_ACTION = {
  SET: 'set',
  DEL: 'delete',
  HAS: 'has',
  CLEAR: 'clear',
}

export const PERMISSION_ROLE = {
  MENU: 'MENU',
  SITE: 'SITE',
}

// 友情链接 的枚举值
export const LINK_TYPE = {
  // 发布媒体
  FBMT: 'fbmt',
  // 采购代理机构
  CGDLJG: 'cgdljg',
  // 区直国企
  QZGQ: 'qzgq',
  // 国资监管
  GZJG: 'gzjg',
  // 合作机构
  HZJG: 'hzjg',
}

export const MENU_ID = {
  // 公示公告
  PURCHASE: Number(process.env.VUE_APP_MENU_ID_PURCHASE),
  // 新闻资讯
  NEWS: Number(process.env.VUE_APP_MENU_ID_NEWS),
  // 资料下载
  FILES: Number(process.env.VUE_APP_MENU_ID_FILES),
  // 常见问答
  HIGH_QA: Number(process.env.VUE_APP_MENU_ID_HIGH_QA),
  // 平台动态/平台资讯(属于新闻资讯的下级菜单)
  PLATFORM_INFO: Number(process.env.VUE_APP_MENU_ID_PLATFORM_INFO),
  // 平台介绍
  PLATFORM_INTRODUCE: Number(process.env.VUE_APP_MENU_ID_PLATFORM_INTRODUCE),
  // 平台规则(业务指南的下级)
  BUSINESS_GUIDE: Number(process.env.VUE_APP_MENU_ID_BUSINESS_GUIDE),
  // 平台规则(业务指南的下级)
  PLATFORM_RULES: Number(process.env.VUE_APP_MENU_ID_PLATFORM_RULES),
}
